import React from 'react';
import styled from 'styled-components';

export const QuantitySelectorContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background-color: #f7fafc;
  padding: 0.4rem 0.5rem;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  width: fit-content;
  flex-shrink: 0;
  min-width: fit-content;

  @media (max-width: 480px) {
    gap: 0.4rem;
    padding: 0.3rem 0.4rem;
    justify-content: center;
  }
`;

export const QtyButton = styled.button`
  background: white;
  border: 1px solid #e2e8f0;
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #2d3748;
  transition: all 0.2s;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  flex-shrink: 0;

  &:hover:not(:disabled) {
    border-color: ${props => props.theme.primary || '#e74c3c'};
    color: ${props => props.theme.primary || '#e74c3c'};
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  i {
    font-size: 0.8rem;
  }
`;

export const QtyValue = styled.span`
  font-size: 1.1rem;
  font-weight: 700;
  color: #2d3748;
  min-width: 20px;
  text-align: center;
`;

interface QuantitySelectorProps {
  quantity: number;
  onDecrease: () => void;
  onIncrease: () => void;
  minQuantity?: number;
  maxQuantity?: number;
  disabled?: boolean;
}

const QuantitySelector: React.FC<QuantitySelectorProps> = ({
  quantity,
  onDecrease,
  onIncrease,
  minQuantity = 1,
  maxQuantity,
  disabled = false,
}) => {
  return (
    <QuantitySelectorContainer>
      <QtyButton 
        onClick={onDecrease} 
        disabled={disabled || quantity <= minQuantity}
        type="button"
      >
        <i className="fas fa-minus"></i>
      </QtyButton>
      <QtyValue>{quantity}</QtyValue>
      <QtyButton 
        onClick={onIncrease} 
        disabled={disabled || (maxQuantity !== undefined && quantity >= maxQuantity)}
        type="button"
      >
        <i className="fas fa-plus"></i>
      </QtyButton>
    </QuantitySelectorContainer>
  );
};

export default QuantitySelector;
